module.exports = __webpack_public_path__ + "static/media/Roboto_medium.e10ca729.woff";